// alt initialization
import Alt from 'alt';
const alt = new Alt();

export default alt;
